import Blockly from "blockly";

/**
 * @override
 * 自定义积木，要采用统一样式，必须在定义积木样式，设置output:'String/Number/Boolean/...'
 *以\u180e字符增加积木内部field之间的间距;
 */

// 运算 +
Blockly.Blocks["math_arithmetic_add"] = {
    init: function() {
        this.jsonInit({
            message0: "\u180e%1 %2 \u180e%3",
            args0: [{
                    type: "input_value",
                    name: "A",
                    check: "Number"
                },
                {
                    type: "field_dropdown",
                    name: "OP",
                    options: [
                        ["%{BKY_MATH_ADDITION_SYMBOL}", "ADD"],
                        ["%{BKY_MATH_SUBTRACTION_SYMBOL}", "MINUS"],
                        ["%{BKY_MATH_MULTIPLICATION_SYMBOL}", "MULTIPLY"],
                        ["%{BKY_MATH_DIVISION_SYMBOL}", "DIVIDE"],
                        ["%{BKY_MATH_POWER_SYMBOL}", "POWER"]
                    ]
                },
                {
                    type: "input_value",
                    name: "B",
                    check: "Number"
                }
            ],
            inputsInline: true,
            output: "Number",
            style: "math_blocks",
            helpUrl: Blockly.Msg['MATH_ARITHMETIC_ADD_HELPURL'],
            extensions: ["math_op_tooltip"]
        });
    }
};

Blockly.Python["math_arithmetic_add"] = function(block) {
    // Basic arithmetic operators, and power.
    var OPERATORS = {
        ADD: [" + ", Blockly.Python.ORDER_ADDITIVE],
        MINUS: [" - ", Blockly.Python.ORDER_ADDITIVE],
        MULTIPLY: [" * ", Blockly.Python.ORDER_MULTIPLICATIVE],
        DIVIDE: [" / ", Blockly.Python.ORDER_MULTIPLICATIVE],
        POWER: [" ** ", Blockly.Python.ORDER_EXPONENTIATION]
    };
    var tuple = OPERATORS[block.getFieldValue("OP")];
    var operator = tuple[0];
    var order = tuple[1];
    var argument0 = Blockly.Python.valueToCode(block, "A", order) || "0";
    var argument1 = Blockly.Python.valueToCode(block, "B", order) || "0";
    var code = argument0 + operator + argument1;
    return [code, order];
};
// 运算 +
Blockly.Blocks["create_new_block"] = {
    init: function() {
        this.jsonInit({
            message0: "%1 %2 %3 %4",
            args0: [{
                    type: "field_label_serializable",
                    name: "NAME",
                    text: "参数一"
                },
                {
                    type: "field_number",
                    name: "NAME",
                    value: 0
                },
                {
                    type: "field_label_serializable",
                    name: "NAME",
                    text: "参数二"
                },
                {
                    type: "field_number",
                    name: "NAME",
                    value: 0
                }
            ],
            previousStatement: null,
            nextStatement: null,
            colour: 230,
            tooltip: "",
            helpUrl: ""
        });
    }
};

Blockly.Python["create_new_block"] = function(block) {
    // Basic arithmetic operators, and power.
    var number_name = block.getFieldValue("NAME");
    var number_name2 = block.getFieldValue("NAME");
    // TODO: Assemble Python into code variable.
    var code = "...\n";
    return code;
};

//  比较运算< = >
Blockly.Blocks["logic_compare_1"] = {
    init: function() {
        this.jsonInit({
            // Block for comparison operator比较逻辑.> < =
            message0: "\u180e%1\u180e %2 %3",
            args0: [{
                    type: "input_value",
                    name: "A"
                },
                {
                    type: "field_dropdown",
                    name: "OP",
                    options: [
                        ["=", "EQ"],
                        ["\u2260", "NEQ"],
                        ["\u200F<", "LT"],
                        ["\u200F\u2264", "LTE"],
                        ["\u200F>", "GT"],
                        ["\u200F\u2265", "GTE"]
                    ]
                },
                {
                    type: "input_value",
                    name: "B"
                }
            ],
            inputsInline: true,
            output: "Boolean",
            style: "math_blocks",
            helpUrl: Blockly.Msg['LOGIC_COMPARE_1_HELPURL'],
            // "extensions": ["logic_compare", "logic_op_tooltip"]//扩展
        });
    }
};

Blockly.Python["logic_compare_1"] = function(block) {
    // Comparison operator.
    var OPERATORS = {
        EQ: "==",
        NEQ: "!=",
        LT: "<",
        LTE: "<=",
        GT: ">",
        GTE: ">="
    };
    var operator = OPERATORS[block.getFieldValue("OP")];
    var order = Blockly.Python.ORDER_RELATIONAL;
    var argument0 = Blockly.Python.valueToCode(block, "A", order) || "0";
    var argument1 = Blockly.Python.valueToCode(block, "B", order) || "0";
    var code = argument0 + " " + operator + " " + argument1;
    return [code, order];
};

// 并且/或 与/或 and/or
Blockly.Blocks["logic_operation"] = {
    init: function() {
        this.jsonInit({
            message0: "\u180e%1\u180e %2 \u180e%3",
            args0: [{
                    type: "input_value",
                    name: "A",
                    check: "Boolean"
                },
                {
                    type: "field_dropdown",
                    name: "OP",
                    options: [
                        ["%{BKY_LOGIC_OPERATION_AND}", "AND"],
                        ["%{BKY_LOGIC_OPERATION_OR}", "OR"]
                    ]
                },
                {
                    type: "input_value",
                    name: "B",
                    check: "Boolean"
                }
            ],
            inputsInline: true,
            output: "Boolean",
            style: "math_blocks",
            helpUrl: Blockly.Msg['LOGIC_OPERATION_HELPURL'],
            extensions: ["logic_op_tooltip"]
        });
    }
};

//  Block for negation 真/假.
Blockly.Blocks["logic_boolean"] = {
    init: function() {
        this.jsonInit({
            //  真/假.
            type: "logic_boolean",
            message0: "%1",
            args0: [{
                type: "field_dropdown", //值的类型
                // "type": "field_dropdown",//值的类型
                name: "BOOL",
                options: [
                    //参数选项
                    ["%{BKY_LOGIC_BOOLEAN_TRUE}", "TRUE"],
                    ["%{BKY_LOGIC_BOOLEAN_FALSE}", "FALSE"]
                ]
            }],
            output: "Boolean", //输出
            // "style": "200",
            style: "math_blocks",
            // "style": "logic_blocks",
            // "tooltip": "%{BKY_LOGIC_BOOLEAN_TOOLTIP}",
            helpUrl: Blockly.Msg['LOGIC_BOOLEAN_HELPURL'],
        });
    }
};

Blockly.Python["logic_boolean"] = function(block) {
    // Boolean values true and false.
    var code = block.getFieldValue("BOOL") == "TRUE" ? "True" : "False";
    return [code, Blockly.Python.ORDER_ATOMIC];
};

//  Block for negation 真/假.
Blockly.Blocks["math_single"] = {
    init: function() {
        this.jsonInit({
            message0: "%1 %2",
            args0: [{
                    type: "field_dropdown",
                    name: "OP",
                    options: [
                        ["%{BKY_MATH_SINGLE_OP_ABSOLUTE}", "ABS"],
                        ["%{BKY_MATH_SINGLE_OP_ROOT}", "ROOT"],
                        ["-", "NEG"],
                        ["ln", "LN"],
                        ["log10", "LOG10"],
                        ["e^", "EXP"],
                        ["10^", "POW10"]
                    ]
                },
                {
                    type: "input_value",
                    name: "NUM",
                    check: "Number"
                }
            ],
            output: "Number",
            inputsInline: true,
            style: "math_blocks",
            helpUrl: "%{BKY_MATH_SINGLE_HELPURL}",
            extensions: ["math_op_tooltip"]
        });
    }
};

Blockly.Python["logic_boolean"] = function(block) {
    // Boolean values true and false.
    var code = block.getFieldValue("BOOL") == "TRUE" ? "True" : "False";
    return [code, Blockly.Python.ORDER_ATOMIC];
};

Blockly.Python["math_text"] = function(block) {
    var text_name = block.getFieldValue("NAME");
    // TODO: Assemble Python into code variable.
    var code = "...\n";
    return code;
};

Blockly.defineBlocksWithJsonArray([{
    type: "math_text",
    message0: "请输入 %1",
    args0: [{
        type: "field_input",
        name: "NAME",
        text: "name"
    }],
    style: "math_blocks",
    output: "String",
    tooltip: "",
    helpUrl: "",
    extensions: ["parent_tooltip_when_inline"]
}]); // END JSON EXTRACT (Do not delete this comment.)

// 三角函数sin cos tan...
Blockly.Blocks["math_trig"] = {
    init: function() {
        this.jsonInit({
            message0: "%1 %2",
            args0: [{
                    type: "field_dropdown",
                    name: "OP",
                    options: [
                        ["%{BKY_MATH_TRIG_SIN}", "SIN"],
                        ["%{BKY_MATH_TRIG_COS}", "COS"],
                        ["%{BKY_MATH_TRIG_TAN}", "TAN"],
                        ["%{BKY_MATH_TRIG_ASIN}", "ASIN"],
                        ["%{BKY_MATH_TRIG_ACOS}", "ACOS"],
                        ["%{BKY_MATH_TRIG_ATAN}", "ATAN"]
                    ]
                },
                {
                    type: "input_value",
                    name: "NUM",
                    check: "Number"
                }
            ],
            output: "Number",
            style: "math_blocks",
            inputsInline: true,
            helpUrl: "%{BKY_MATH_TRIG_HELPURL}",
            extensions: ["math_op_tooltip"]
        });
    }
};

// 四舍五入积木
Blockly.Blocks["math_round"] = {
    init: function() {
        this.jsonInit({
            message0: "%1 %2",
            args0: [{
                    type: "field_dropdown",
                    name: "OP",
                    options: [
                        ["%{BKY_MATH_ROUND_OPERATOR_ROUND}", "ROUND"],
                        ["%{BKY_MATH_ROUND_OPERATOR_ROUNDUP}", "ROUNDUP"],
                        ["%{BKY_MATH_ROUND_OPERATOR_ROUNDDOWN}", "ROUNDDOWN"]
                    ]
                },
                {
                    type: "input_value",
                    name: "NUM",
                    check: "Number"
                }
            ],
            output: "Number",
            style: "math_blocks",
            inputsInline: true,
            helpUrl: "%{BKY_MATH_ROUND_HELPURL}",
            tooltip: "%{BKY_MATH_ROUND_TOOLTIP}"
        });
    }
};
// 四舍五入积木
Blockly.Blocks["logic_null"] = {
    init: function() {
        this.jsonInit({
            message0: "%{BKY_LOGIC_NULL}",
            output: "Boolean",
            style: "math_blocks",
            tooltip: "%{BKY_LOGIC_NULL_TOOLTIP}",
            helpUrl: "%{BKY_LOGIC_NULL_HELPURL}"
        });
    }
};

// 四舍五入积木math_change类型应用到变量 “将XX增加”的积木中
Blockly.Blocks["math_change"] = {
    init: function() {
        this.jsonInit({
            message0: "%{BKY_MATH_CHANGE_TITLE}",
            args0: [{
                    type: "field_variable",
                    name: "VAR",
                    variable: "%{BKY_MATH_CHANGE_TITLE_ITEM}"
                },
                {
                    type: "input_value",
                    name: "DELTA",
                    check: "Number"
                }
            ],
            previousStatement: null,
            nextStatement: null,
            inputsInline: true,
            style: "variable_blocks",
            helpUrl: "%{BKY_MATH_CHANGE_HELPURL}",
            extensions: ["math_change_tooltip"]
        });
    }
};

Blockly.Python["math_change"] = function(block) {
    // Add to a variable in place.
    Blockly.Python.definitions_["from_numbers_import_Number"] =
        "from numbers import Number";
    var argument0 =
        Blockly.Python.valueToCode(block, "DELTA", Blockly.Python.ORDER_ADDITIVE) ||
        "0";
    var varName = Blockly.Python.variableDB_.getName(
        block.getFieldValue("VAR"),
        Blockly.Variables.NAME_TYPE
    );
    return (
        varName +
        " = (" +
        varName +
        " if isinstance(" +
        varName +
        ", Number) else 0) + " +
        argument0 +
        "\n"
    );
};

// 奇数或者偶数
Blockly.Blocks["math_number_property"] = {
    init: function() {
        this.jsonInit({
            message0: "\u180e%1 %2",
            args0: [{
                    type: "input_value",
                    name: "NUMBER_TO_CHECK",
                    check: "Number"
                },
                {
                    type: "field_dropdown",
                    name: "PROPERTY",
                    options: [
                        ["%{BKY_MATH_IS_EVEN}", "EVEN"],
                        ["%{BKY_MATH_IS_ODD}", "ODD"],
                        ["%{BKY_MATH_IS_PRIME}", "PRIME"],
                        ["%{BKY_MATH_IS_WHOLE}", "WHOLE"],
                        ["%{BKY_MATH_IS_POSITIVE}", "POSITIVE"],
                        ["%{BKY_MATH_IS_NEGATIVE}", "NEGATIVE"],
                        ["%{BKY_MATH_IS_DIVISIBLE_BY}", "DIVISIBLE_BY"]
                    ]
                }
            ],
            inputsInline: true,
            output: "Boolean",
            style: "math_blocks",
            tooltip: "%{BKY_MATH_IS_TOOLTIP}",
            helpUrl: Blockly.Msg['MATH_NUMBER_PROPERTY_HELPURL'],
            mutator: "math_is_divisibleby_mutator"
        });
    }
};

Blockly.Python["math_change"] = function(block) {
    // Add to a variable in place.
    Blockly.Python.definitions_["from_numbers_import_Number"] =
        "from numbers import Number";
    var argument0 =
        Blockly.Python.valueToCode(block, "DELTA", Blockly.Python.ORDER_ADDITIVE) ||
        "0";
    var varName = Blockly.Python.variableDB_.getName(
        block.getFieldValue("VAR"),
        Blockly.Variables.NAME_TYPE
    );
    return (
        varName +
        " = (" +
        varName +
        " if isinstance(" +
        varName +
        ", Number) else 0) + " +
        argument0 +
        "\n"
    );
};

// 列表中的求和、最小值、最大值、众数、中位数、标准差、列表随机项等
Blockly.Blocks["math_on_list"] = {
    init: function() {
        this.jsonInit({
            message0: "%1 %2",
            args0: [{
                    type: "field_dropdown",
                    name: "OP",
                    options: [
                        ["%{BKY_MATH_ONLIST_OPERATOR_SUM}", "SUM"],
                        ["%{BKY_MATH_ONLIST_OPERATOR_MIN}", "MIN"],
                        ["%{BKY_MATH_ONLIST_OPERATOR_MAX}", "MAX"],
                        ["%{BKY_MATH_ONLIST_OPERATOR_AVERAGE}", "AVERAGE"],
                        ["%{BKY_MATH_ONLIST_OPERATOR_MEDIAN}", "MEDIAN"],
                        ["%{BKY_MATH_ONLIST_OPERATOR_MODE}", "MODE"],
                        ["%{BKY_MATH_ONLIST_OPERATOR_STD_DEV}", "STD_DEV"],
                        ["%{BKY_MATH_ONLIST_OPERATOR_RANDOM}", "RANDOM"]
                    ]
                },
                {
                    type: "input_value",
                    name: "LIST",
                    check: "Array"
                }
            ],
            output: "Number",
            style: "math_blocks",
            helpUrl: "%{BKY_MATH_ONLIST_HELPURL}",
            mutator: "math_modes_of_list_mutator",
            inputsInline: true,
            extensions: ["math_op_tooltip"]
        });
    }
};